import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import './index.css'
import './assets/styles/modern-effects.css'

// 导入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// 导入动画插件
import { MotionPlugin } from '@vueuse/motion'
import ScrollReveal from 'scrollreveal'
import Toast from 'vue-toastification'
import "vue-toastification/dist/index.css"

// 初始化 ScrollReveal
const sr = ScrollReveal({
    distance: '60px',
    duration: 1500,
    delay: 400,
    reset: false
})

const app = createApp(App)

// 使用 Element Plus
app.use(ElementPlus, {
  locale: zhCn,
})

// 使用动画插件
app.use(MotionPlugin)

app.use(router)
app.use(store)


// 将 ScrollReveal 实例添加到全局属性中
app.config.globalProperties.$sr = sr

const toastOptions = {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false
}

app.use(Toast, toastOptions)

app.mount('#app')

// 添加滚动动画监听
const observerOptions = {
  threshold: 0.1
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible')
    }
  })
}, observerOptions)

// 当DOM加载完成后，为所有scroll-reveal元素添加观察器
document.addEventListener('DOMContentLoaded', () => {
  const scrollElements = document.querySelectorAll('.scroll-reveal')
  scrollElements.forEach(el => observer.observe(el))
})
